import IChartData from "../../interfaces/IChartData"
import IParkingAvailabilityModel from "../../interfaces/IParkingAvailabilityModel"

export interface DevDocsState {
    dateTime: Date;
    facilityName: string;
    parkingAvailabilityModel: IParkingAvailabilityModel | undefined;
    locations: Array<string>;
    parkingAvailabilityModels: Array<IParkingAvailabilityModel>;
    chartData: Array<IChartData>;
    fullYearLocationData: Array<IChartData>;
}

export const SET_DATE_TIME = 'SET_DATE_TIME'
export const SET_FACILITY_NAME = 'SET_FACILITY_NAME'
export const SET_PARKING_AVAILABILITY_MODEL = 'SET_PARKING_AVAILABILITY_MODEL'
export const SET_LOCATIONS = 'SET_LOCATIONS'
export const SET_PARKING_AVAILABILITY_MODELS = 'SET_PARKING_AVAILABILITY_MODELS'
export const SET_CHART_DATA = 'SET_CHART_DATA'
export const SET_FULL_YEAR_LOCATION_DATA = 'SET_FULL_YEAR_LOCATION_DATA'

export interface SetDateTimeAction {
    type: typeof SET_DATE_TIME
    payload: {
        dateTime: Date;
    }
}

export interface SetFacilityNameAction {
    type: typeof SET_FACILITY_NAME
    payload: {
        facilityName: string;
    }
}

export interface SetParkingAvailabilityModelAction {
    type: typeof SET_PARKING_AVAILABILITY_MODEL
    payload: {
        parkingAvailabilityModel: IParkingAvailabilityModel;
    }
}

export interface SetLocationsAction {
    type: typeof SET_LOCATIONS
    payload: {
        locations: string[];
    }
}

export interface SetParkingAvailabilityModelsAction {
    type: typeof SET_PARKING_AVAILABILITY_MODELS
    payload: {
        parkingAvailabilityModels: Array<IParkingAvailabilityModel>;
    }
}


export interface SetChartDataAction {
    type: typeof SET_CHART_DATA
    payload: {
        chartData: Array<IChartData>;
    }
}

export interface SetFullYearLocationData {
    type: typeof SET_FULL_YEAR_LOCATION_DATA
    payload: {
        fullYearLocationData: Array<IChartData>;
    }
}

export type DevDocActionTypes = SetDateTimeAction | SetFacilityNameAction | SetParkingAvailabilityModelAction | SetLocationsAction | SetParkingAvailabilityModelsAction | SetChartDataAction | SetFullYearLocationData